export const PROPRIEDADES = {
  MASCARA: 'MASCARA',
  TAMANHO: 'TAMANHO',
  ORDEM: 'ORDEM',
  MINIMO: 'MINIMO',
  MAXIMO: 'MAXIMO',
  SOMENTE_LEITURA: 'SOMENTE_LEITURA',
  PLACEHOLDER: 'PLACEHOLDER',
  OBRIGATORIEDADE: 'OBRIGATORIEDADE',
  PERIODO_MINIMO: 'PERIODO_MINIMO',
  PERIODO_MAXIMO: 'PERIODO_MAXIMO',
  VALOR_MINIMO: 'VALOR_MINIMO',
  VALOR_PADRAO: 'VALOR_PADRAO',
  VALOR_MAXIMO: 'VALOR_MAXIMO',
  PADRAO: 'PADRAO',
  MODO_ENTRADA: 'MODO_ENTRADA',
};

export const INPUT_TYPES = {
  NUMBER: 'NUMERICO',
  TEXT: 'TEXTO',
  IMAGE: 'CAPTURA_IMAGEM',
  ALPHA: 'ALFABETICO',
  ALFANUMERICO: 'ALFANUMERICO',
  INTEGER: 'INTEIRO',
  BOOL: 'BOLEANO',
  DECIMAL: 'DECIMAL',
  NUMERIC: 'NUMERICO',
  SELECT_OPTIONS: 'SELECT_OPTIONS',
  DATE: 'DATA',
};

export const REGEX_TEXTO_ALFABETICO =
  /^[a-zA-ZáàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ\s]+$/;

export enum STORAGE_KEYS {
  APP_STATE = 'APP_STATE',
  POSITION = 'POSITION',
  METADATA = 'METADATA',
  TELEFONE_PESSOA = 'TELEFONE_PESSOA',
  ENV_CONFIG = 'ENV_CONFIG',
  CAPTCHA_RESPONSE = 'CAPTCHA_RESPONSE',
}
